import { c as _c } from "react/compiler-runtime";
import { cn } from '@morpho-org/ui-v6/utils';
import { memo } from 'react';
import { Status } from '@/contexts/Transaction/StateMachine/helpers';
interface StatusIndicatorProps {
  status?: Status;
}
const statusBgClass: Record<Status, string> = {
  [Status.signing]: 'bg-info-foreground motion-safe:animate-pulse',
  [Status.pending]: 'bg-primary motion-safe:animate-pulse',
  [Status.complete]: 'bg-success-foreground',
  [Status.error]: 'bg-destructive-foreground'
};
const StatusIndicator = t0 => {
  const $ = _c(4);
  const {
    status
  } = t0;
  const t1 = status === undefined ? "bg-muted" : statusBgClass[status];
  let t2;
  if ($[0] !== t1) {
    t2 = cn("h-2xs flex-1 rounded-full", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <span className={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default memo(StatusIndicator);